import React, {useState, useEffect, useRef} from 'react';
import {tokenExpiredLoginAgain, hostUrl, siteUrl, highTrafficInnerPages } from '../../constants/global';
import Creatable from 'react-select/creatable';
//import 'react-select/dist/css/react-select.css';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import { Editor } from '@tinymce/tinymce-react';
import { callPageRenderTracking } from '../common/Helper';
import {useNavigate, useParams} from "react-router-dom";
import { NavLink } from "react-router-dom";


function AddNewTopic() {

    
    const [useripaddress, setUserIpAddress] =  useState("");
    const [topictitle, setTopicTitle] =  useState("");
    const [topiccontent, setTopicContent] = useState("");
    const [options,setOptions] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [responsemessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState(undefined);

    var fileObj = [];
    var fileArray = [];

    const editorRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // const options = [
    //     { value: 'chocolate', label: 'Chocolate' },
    //     { value: 'strawberry', label: 'Strawberry' },
    //     { value: 'vanilla', label: 'Vanilla' },
    // ];

    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() =>{

        callPageRenderTracking({page_title:'Topic Add',page_link:window.location.href});

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        /*******get categories from server*********/
        const data = { callingaction: 'topic_category' };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 
            if(actualData.status=='success'){
                setOptions(actualData.data)
            }else if(actualData.status=='validationerror'){
                dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                //alert(tokenExpiredLoginAgain);
                navigate('/login/?message='+tokenExpiredLoginAgain);
            }
            //setResponseMessage({status:"success",message:"We have send the topic for approval"});
        
        }).catch(rejected => {
            //setResponseMessage({status:"error",message:highTrafficInnerPages});
        });
     



      /*******add class on body*****/
      document.body.classList.add('white-bg-header', 'show-search-box');
      return () => {
        document.body.classList.remove('white-bg-header', 'show-search-box');
      }
    },[]);


    const handleInputChange = (e) => {

        if(e.target.name==="topic-title"){
            setTopicTitle(e.target.value);
        }

        if(e.target.name==="topic-content"){
            setTopicContent(e.target.value);
        }

        if(e.target.name==="add-anonymously"){
            setIsChecked(!isChecked);
        }

    }

    const submitTopic = (e) => {
        e.preventDefault();

        console.log(selectedOption);
        setResponseMessage();

        /*******get the user ip address*********/
        //https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708
        fetch('https://ipwho.is/').then(response => {
            return response.json();
        }).then((res) => {
            if(res.IPv4){
                setUserIpAddress(res.IPv4);
            }
        });

        var topiccontenteditor = editorRef.current.getContent();

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = new FormData();
        data.append("callingaction","topic_add");
        data.append("title",topictitle);
        data.append("content",topiccontenteditor);
        data.append("anonymously",isChecked);
        data.append('selectedCategories',JSON.stringify(selectedOption));
        data.append("userip",useripaddress);
        
        /*******Image append******/
        if(selectedFiles){
            for (var i = 0; i < selectedFiles.length; i++) {
                data.append('file[]', selectedFiles[i]);
            }

            if(i>=6){
                setResponseMessage({status:"error",message:"Only 5 images can upload"});
                return;
            }
        }


        console.log(data);
        /******Define Headers*****/
        var myHeaders = new Headers();
        myHeaders.append('Authorization',token);
        myHeaders.append('username',username);
        myHeaders.append('Host',hostUrl);

        const requestOptions = {
                method: 'POST',
                body: data,
                headers: myHeaders,
            };

        setLoading(true);
        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle_staging',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 
            
            setResponseMessage({status:"success",message:"The query has been shared with the moderator"});
            setTopicTitle("");
            setTopicContent("");
            setSelectedFiles("");
            setIsChecked(false);
            setLoading(false);
       
        }).catch(rejected => {
            setResponseMessage({status:"error",message:highTrafficInnerPages});
        });


    }

    /******Upload Multiple Images******/
    const uploadMultipleFiles = (e) =>  {
        fileObj.push(e.target.files);
        console.log(fileObj);
        for (let i = 0; i < fileObj[0].length; i++) {
            fileArray.push(fileObj[0][i])
        }
        console.log("below");
        console.log(fileArray);
        setSelectedFiles(fileArray)
    }
    const uploadFiles = (e) =>  {
        e.preventDefault()
        console.log(selectedFiles)
    }

    const deleteFile = (e) => {
        const s = selectedFiles.filter((item, index) => index !== e);
        setSelectedFiles(s);
        console.log(s);
      }
    /*******Upload Multiple image end********/

    /****Close button click*****/
    const closeHandleClick = () => {
        navigate(-1);
    }
    

  return (
    <div className='topic-main-box'>
    
    <span onClick={()=> closeHandleClick()} className='close-query-popup'><span class="material-icons-outlined">close</span> Close</span>

    <div className='topic-container'>
    <div className="topic-inner-box">
        
        <h2 className='page-title'>Ask New Query</h2>

        <form onSubmit={submitTopic}>

            <div className="topic-field">
                <label>Query</label>
                <textarea value={topictitle} name="topic-title" onChange={(e) => handleInputChange(e)} required />
            </div>

            <div className="topic-field">
                <label>Description</label>

                <Editor
                    apiKey="r5ixlsvtvg9v4rx95avemaeyvniv0ujxz8na67bi6kydcsx0"
                    onInit={(evt, editor) => editorRef.current = editor}
                    initialValue={topiccontent}
                    init={{
                        height: 400,
                        menubar: false,
                        branding: false,
                        toolbar: 'undo redo | formatselect | ' +
                        'bold italic | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                />

            </div>

            {/************/}
            <div className='query-two-colum'>

                <div className='query-col'>
                    <Creatable
                        defaultValue={selectedOption}
                        onChange={setSelectedOption}
                        options={options}
                        isMulti className='category-select'
                        required
                    />
                </div>
            

            
                <div className='query-col'>
                    <div className='query-file-upload'>
                        <input id='query_input' type="file" accept=".jpg, .jpeg, .png" onChange={uploadMultipleFiles} multiple />
                        <label htmlFor='query_input'><span className="material-icons-outlined">upload</span> Upload Images</label>
                    </div>

                    {/*****Image upload section****/}
                    <div className="multi-preview">
                            {(selectedFiles || []).map((url,index) => (
                                <div className='multi-preview-col' key={index}>
                                    <img src={URL.createObjectURL(url)} alt="" />
                                    <button className='multi-preview-delete' type="button" onClick={() => deleteFile(index)}>
                                        <span className="material-icons-outlined">delete</span>
                                    </button>
                                </div>
                            ))}
                    </div>
                </div>

            </div>

            {/******Image upload section end*******/}
            
            <div className="topic-checkbox">
                <input type="checkbox" id="add-anonymously" name="add-anonymously" checked={isChecked} onChange={(e) => handleInputChange(e)} />
                <label htmlFor="add-anonymously"> Post Anonymously</label>
                
            </div>

            {responsemessage && <div className="response-message"><span className={responsemessage.status}>{responsemessage.message}</span></div>}


            <div className="back_btn_box">
                <button type="submit" className="submit-topic">{loading && <span className="material-icons-outlined spin">motion_photos_on</span>}Submit</button>
            </div>

        </form>
    </div>
    </div>
    </div>

  )
}

export default  AddNewTopic